import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { selectBudgetType } from '../actions/index';

const budgetTypes = [
  { type: 'budget', title: '預算(千元)' },
  { type: 'percentage', title: '預算百分比' },
  { type: 'budgetPerPersent', title: '預算/人口數(千元/人)' },
  { type: 'budgetPerArea', title: '預算/土地面積(千元/平方公里)' },
];

class BudgetType extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectBudgetType = this.handleSelectBudgetType.bind(this);
  }
  handleSelectBudgetType(e) {
    this.props.selectBudgetType(e.target.value);
  }
  render() {
    return (
      <div className="budget-type">
        {budgetTypes.map((b) =>
          <div
            className="budget-input"
            key={b.type}
          >
            <input
              type="radio" name="budget-type" value={b.type}
              id={`select-${b.type}`}
              className="input"
              checked={this.props.budgetType === b.type}
              onChange={this.handleSelectBudgetType}
            />
            <label htmlFor={`select-${b.type}`}>{b.title}</label>
          </div>
        )}
      </div>
    );
  }
}

BudgetType.propTypes = {
  budgetType: PropTypes.string,
  selectBudgetType: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    budgetType: state.budget.type,
  };
}

export default connect(mapStateToProps, { selectBudgetType })(BudgetType);



/** WEBPACK FOOTER **
 ** ./src/components/budget-type.js
 **/